import { generateUniqueString } from "@medicusunion/front-utils";
import dayjs from "dayjs";
import { Send } from "iconsax-reactjs";
import { FC, FormEventHandler, useState } from "react";
import { useTranslation } from "react-i18next";
import { call } from "@/services/call";
import { addChatMessage } from "@/store/features/chat/slice";
import { useAppDispatch } from "@/store/hooks";
import { StyledChatInput } from "./styled";

const ChatInput: FC = () => {
  const {t} = useTranslation();

  const dispatch = useAppDispatch();

  const [text, setText] = useState('');

  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    const trimmed = text.trim();

    if (trimmed) {
      setText('');

      const message = {
        id: generateUniqueString(),
        sender: 'me',
        text,
        date: dayjs().format(),
      };

      call.sendChatMessage(message);
      dispatch(addChatMessage(message));
    }
  };

  return (
    <StyledChatInput>
      <form onSubmit={onSubmit}>
        <input type="text" placeholder={t('type_your_message_here')} value={text} onChange={e => setText(e.target.value)} />
        <button>
          <Send color="var(--color-text)" size={24} />
        </button>
      </form>
    </StyledChatInput>
  );
};

export default ChatInput;